import { HttpStatusCode } from "axios";
import type LxcError from "~/core/models/LxcError.class";
import { i18n } from "~/plugins/i18n";

export function getLicenseUploadErrors(error: LxcError): string {
  let errorMessages = `<div class="font-semibold flex flex-col gap-2">`;
  const maxErrorsToDisplay = 6;

  if (error.status === HttpStatusCode.BadRequest && error.codes) {
    error.codes.slice(0, maxErrorsToDisplay).forEach((errorCode) => {
      const messageKey = `license.upload.errors.${errorCode.code}`;
      errorMessages = errorMessages.concat(
        `<span>${
          i18n.global.te(messageKey, "en")
            ? i18n.global.t(messageKey, errorCode.params)
            : i18n.global.t("errors.httpStatusCodes.500.title")
        }</span>`,
      );
    });
  } else {
    errorMessages = errorMessages.concat(
      `<span>${i18n.global.t("errors.httpStatusCodes.500.title")}</span>`,
    );
  }
  errorMessages = errorMessages.concat(`</div>`);
  return errorMessages;
}
